/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "Team Skill Matcher",
    description:
      "Full-stack hackathon team-matching platform with JWT authentication. Processes 100+ users in <500ms, 40% faster queries, CI/CD deployment from 5 to 2 minutes.",
    url: "https://skill-matcher-snowy.vercel.app",
  },
  {
    title: "Human Face Attribute Detection",
    description:
      "Real-time facial analysis system detecting 7+ attributes (age, gender, emotion) with 85% accuracy, processing 50+ images/sec.",
    url: "https://github.com/JefCristo/face-attribute-detection", // or a link if hosted
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <div className="section-heading">
        <p className="eyebrow">Selected work</p>
        <h2>Portfolio</h2>
      </div>
      <div className="portfolio-layout">
        <div className="portfolio-image">
          <img
            src={image}
            alt={imageAltText}
          />
        </div>
        <div className="project-grid">
          {projectList.map((project) => (
            <article className="project-card" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3>{project.title}</h3>
                <span className="card-arrow" aria-hidden="true">-&gt;</span>
              </a>
              <p className="small">{project.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
